var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-tab-wrap",class:_vm.$i18n.locale},[_c('div',{class:['iconfont', _vm.icon]}),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.label)+": "+_vm._s(_vm.value)+_vm._s(_vm.unit))])])}
var staticRenderFns = []

export { render, staticRenderFns }